import ArticleLayout from '../article/components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function JakZaczacPage() {
  return <ArticleLayout article={articles[3]} />;
}